import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Art",
  "description": "",
  "published": "2006-09-15T00:00:00.000Z",
  "redirect_from": ["/blog/art/swizec/384"],
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`So, dear poet`}<br parentName="p"></br>{`
`}{`in the end you shall perish`}<br parentName="p"></br>{`
`}{`naught will resist`}<br parentName="p"></br>{`
`}{`but a pile of ash`}<br parentName="p"></br>{`
`}{`and poems old.`}</p>
    <p>{`Art, what is art? People would conclude that it is the only longlasting aspect of humanity. Why the oldest known relics and what have you were mere art at the time of their conception. But is there anything known of the creators? Of course not, they were mere henchman of the higher being that is mind. The mind that perishes even sooner than the body that entraps it. Yes, the mind, it is the first to sucumb to the deadly perversions of life; in a select few it persists long enough to transfer onto a lasting enough medium to be remembered in the form of pretty art.`}</p>
    <p>{`As some of you may have noticed the so called comic that resides on this website has been updated a whopping five days ago on an odd Sunday. But the news, oh no, not the news, who updates the news. I mean really, still the news is always only about the vain stupidity of nothing very interesting. There is no real constraint as to what is considered important news anymore, people just get fed some utter bullshit and love it.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      